export default "__VITE_ASSET__XSB$_khd__"